import React, { FunctionComponent, useLayoutEffect, useState } from "react";
import styles from "./BackgroundPattern.module.scss";
import BackgroundPatternProps from "./BackgroundPatternProps.interface";

import combineClasses from "helpers/combine-classes";
import useWrapperStyles from "./hooks/useWrapperStyles";
import urlBuilder from "app/umbraco/helpers/urlBuilder";

const BackgroundPattern: FunctionComponent<BackgroundPatternProps> = (props): JSX.Element => {
    const wrapperStylesElementRef = useWrapperStyles(props);

    const [lazyBackgroundImage, setLazyBackgroundImage] = useState<any>();

    useLayoutEffect(() => {
        setTimeout(() => {
            const newImg = new Image();

            newImg.onload = () => {
                setLazyBackgroundImage(props?.content.imagePattern.umbracoFile.src);
            };

            newImg.onerror = () => {
                setLazyBackgroundImage("/error-url");
            };

            newImg.src = urlBuilder(props?.content.imagePattern.umbracoFile.src).toString();
        }, 1000);
    }, []);

    return (
        <div className={combineClasses(styles.wrapper, props.className)} ref={wrapperStylesElementRef} style={{ backgroundImage: `url(${urlBuilder(lazyBackgroundImage).toString()})` }}></div>
    );
};

export default BackgroundPattern;

